const VISIBLE_NAMES_COUNT = 2;

/**
 * Renders the Engagements cell of the work site table: the first couple of
 * engagement names, with the remainder rolled up into a "+ N more" line.
 */
export const selectorWorksiteEngagementsSummary = (
  engagementNames: string[]
): { text: string; secondaryText?: string } => {
  if (engagementNames.length === 0) {
    return { text: "–" };
  }

  const hiddenCount = engagementNames.length - VISIBLE_NAMES_COUNT;

  return {
    text: engagementNames.slice(0, VISIBLE_NAMES_COUNT).join(", "),
    secondaryText: hiddenCount > 0 ? `+ ${hiddenCount} more` : undefined
  };
};
